/* eslint-disable no-console */
import ProductListQuery from 'Query/ProductList.query';
import { updateNoMatch } from 'Store/NoMatch/NoMatch.action';
import {
    updateLoadStatus
} from 'Store/ProductList/ProductList.action';
import {
    updateVehicleFinderProductLoading
} from 'Store/VehicleFinder/VehicleFinder.action';
import { QueryDispatcher } from 'Util/Request';

/** @namespace Pwa/Store/PartsFinder/SkuProducts/Dispatcher/SkuProductsDispatcher */
export class SkuProductsDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct();
    }

    onSuccess(response = {}, dispatch, { cb }) {
        const currentPage = 1;
        const args = {};
        const { products = {} } = response;
        const {
            items = [],
            total_count = 0,
            page_info = {}

        } = products;

        const { total_pages = 1 } = page_info;

        dispatch(updateLoadStatus(false));
        dispatch(cb(items,
            currentPage,
            total_count,
            total_pages,
            args));
        dispatch(updateVehicleFinderProductLoading(false));
    }

    onError(_, dispatch) {
        dispatch(updateNoMatch(true));
        dispatch(updateVehicleFinderProductLoading(false));
    }

    // eslint-disable-next-line no-unused-vars
    prepareRequest(options, dispatch) {
        return ProductListQuery.getVehicleQuery(options);
    }
}

export default new SkuProductsDispatcher();
